<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Book-Title--Front-Matter-" lang="en-US">Diary of a Witchcraft Shop</p>
<p class="ORIM-Author-Name--Front-Matter-" lang="en-US">Trevor Jones and Liz Williams<br/>
				Illustrated by Arthur Billington</p>
<p class="ORIM-Author-Name--Front-Matter-" lang="en-US"><img alt="ORIM logo" src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?be7de1b6